/* eslint-disable-next-line */
import React, { useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux'
import auth from '../../services/auth/AuthProvider';
import LoadingPage from '../Loading/loadingPage';

const OTCLoginCallback = () => {

    const config = useSelector(state => state.config || {}, shallowEqual)

    useEffect(() => {
        const authConfig = {
            cas: config.CASConfig,
            auth: config.authConfig
        }
        auth.initProvider(authConfig);
        auth.handleAuthentication().then(() => { });
    }, [])

    return (<LoadingPage />)
}

export default OTCLoginCallback